module.exports = __webpack_public_path__ + "img/706.31f2de11.gif";